import React, { useState, useEffect, useContext, useRef } from 'react';
import { useForm } from 'react-hook-form';
import Layout from '../components/Layout';
import Button from '../components/Button';
import Steps from '../components/Steps';
import Back from '../components/Back';
import { GlobalContext } from '../reducers/global';
import Measurement from '../components/Measurement';
import langs from '../translations/langs';

const Step3 = ({ setPage }) => {
  const nowDate = new Date().toISOString().slice(0, 10);
  const {
    state: {
      measurements: { values },
      options: { measurementSystem, language, dataSet },
    },
    dispatch,
  } = useContext(GlobalContext);
  // set default date to today
  if (!values[0].date) { 
    values[0].date = nowDate; 
  }

  const [measurements, setMeasurements] = useState(values);
  const { step3 } = langs[language];

  useEffect(() => {
    window.scrollTo(0, 150);
  }, []);

  const onSubmit = () => {
    setPage('results');
    window && window.scrollTo(0, 150);
  };

  useEffect(() => {
    dispatch({
      type: 'MEASUREMENTS_SET',
      values: measurements.map((val, index) => {
        const measureDate = new Date(Date.parse(val.date));
        return {
          date: val.date,
          dateYYYY: measureDate.getFullYear(),
          dateMM: measureDate.getMonth(),
          dateDD: measureDate.getDate(),
          height: val.height,
          weight: val.weight,
          selected: index === 0,
        };
      }),
    });
  }, [measurements, dispatch, measurementSystem]);

  const { register, handleSubmit, getValues, errors } = useForm();

  const renderMeasurements = measurements.map((_, index) => {
    const current = [...measurements];
    return (
      <>
        <Measurement
          measurementSystem={measurementSystem}
          dataSet={dataSet}
          index={index}
          state={measurements}
          setState={setMeasurements}
          register={register}
          errors={errors}
          getValues={getValues}
        />
        {index !== 0 && (
          <Button
            text={step3.removeButton}
            onClick={() => {
              current.splice(index, 1);
              setMeasurements(current);
            }}
          />
        )}
      </>
    );
  });

  return (
    <Layout>
      <Back
        onClick={() => {
          setPage('step2');
        }}
      />
      <Steps current={3} />
      <h3>{step3.title}</h3>
      <form className="form" onSubmit={handleSubmit(onSubmit)}>
        {renderMeasurements}
        <div className="column-1">
          <Button
            buttonStyle="secondary"
            text={step3.previousButton}
            onClick={() => {
              setMeasurements([...measurements, { date:nowDate }]);
            }}
          />
          <p>{step3.previousText}</p>
        </div>
        <Button id="calculator-submit" text={step3.nextButton} type="submit" />
      </form>
    </Layout>
  );
};

export default Step3;
